<template>
  <v-card-text>
    <v-tabs v-model="activeTab" show-arrows>
      <v-tab>Feedback</v-tab>
      <v-tab>Objectives</v-tab>
      <v-tab>Summary</v-tab>
    </v-tabs>
    <v-tabs-items v-model="activeTab" class="py-3">
      <v-tab-item>
        <PdpFeedbackTab
          :employee="employee"
          :rolesOfUser="rolesOfUser"
        />
      </v-tab-item>
      <v-tab-item>
        <PdpTab
          :employee="employee"
          :rolesOfUser="rolesOfUser"
        />
      </v-tab-item>
      <v-tab-item>
        <PdpSummaryTab
          :employee="employee"
          :rolesOfUser="rolesOfUser"
        />
      </v-tab-item>
    </v-tabs-items>
  </v-card-text>
</template>

<script>
export default {
  name: 'PdpTabs',
  components: {
    PdpFeedbackTab: () => import('@/components/employee/employee_details_tabs/PdpFeedbackTab.vue'),
    PdpTab: () => import('@/components/employee/employee_details_tabs/PdpTab.vue'),
    PdpSummaryTab: () => import('@/components/employee/employee_details_tabs/PdpSummaryTab.vue')
  },
  props: {
    employee: {
      required: true,
      type: Object
    },
    rolesOfUser: {
      required: false,
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      activeTab: 0
    }
  }
}
</script>
